module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 350 51",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }